import {Injectable} from "@angular/core";
import {CoreErrorHandlerBaseService} from "@core/services/error-handler-base/core-error-handler-base.service";
import {IAlertControllerCreate} from "@shared/interfaces/alert-controller-create.interface";

@Injectable({
  providedIn: 'root'
})
export class SharedRegisterErrorHandlerService extends CoreErrorHandlerBaseService {

  override _formatAlertFor400(status: number, name: string, message: any): IAlertControllerCreate {
    const passwordErrors = ['PasswordTooShort', 'PasswordRequiresUpper', 'PasswordRequiresLower', 'PasswordRequiresDigit'];
    const hasPasswordError = Array.isArray(message) && message.some(error =>
      passwordErrors.includes(error?.Description) || passwordErrors.includes(error?.Parameters?.Code)
    );
    return {
      header: '',
      subHeader: this._translateService.instant(hasPasswordError
        ? 'LOGIN.FORM-PASSWORD.ERRORS.REQUIREMENTS'
        : 'LOGIN.REGISTER_NEW_USER.ERRORS.400_MESSAGE'),
      message: '',
      buttons: [
        { text: 'OK' }
      ]
    };
  }
}
